import { render } from "./ClusterProvider.vue?vue&type=template&id=2501beb8"
import script from "./ClusterProvider.vue?vue&type=script&lang=js"
export * from "./ClusterProvider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__